import type { UniverseReference } from '@wecasa/common/src/types/commons';
import type { ProChoice } from '@wecasa/common/src/types/customer';
import { isWanted } from '@wecasa/common/src/utils/previous-pros';

import useBasketSection from '../../../../../hooks/use-basket-section';
import { PREVIOUS_PROS_PATH, RECAP_PATH, route } from '../../../../../steps/steps';
import EligibleProsCount from './eligible-pros-count';
import ProChoices from './pro-choices';

type ProSectionProps = {
  proChoices: ProChoice[];
  universeRef: UniverseReference;
  shouldHideEligiblePros?: boolean;
};

const ProSection = ({ proChoices, universeRef, shouldHideEligiblePros = false }: ProSectionProps) => {
  const proChoicesSection = useBasketSection({
    data: proChoices.filter(isWanted).length > 0,
    sectionLocations: [route(PREVIOUS_PROS_PATH)],
  });
  const eligibleProsCountSection = useBasketSection({ data: false, sectionLocations: [route(RECAP_PATH)] });

  if (proChoicesSection.hasData) {
    return <ProChoices proChoices={proChoices} hasTopSeparator hasBottomSeparator={false} />;
  }

  if (eligibleProsCountSection.isOpen && !shouldHideEligiblePros) {
    /**
     * We use isOpen as the display condition because we
     * want to show this section on the recap screen only
     */
    return <EligibleProsCount universeRef={universeRef} />;
  }

  return null;
};

export default ProSection;
